import { ProductDocument } from 'models/product';
import { Fragment } from 'react';

export default function PartNumbersTab({
  product,
}: {
  product: ProductDocument;
}) {
  return (
    <>
      <div className="mt-8 hidden sm:flex">
        {product.variations?.length &&
        product.variations.some((v) => v.mpn?.length) ? (
          <div className="relative max-h-[40rem] w-full overflow-y-scroll border-[1px] border-zinc-200">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="sticky top-0 border-r border-[#D9D9D9] bg-[#222] p-6 text-left text-[1.8rem] font-semibold text-white">
                    Product Style
                  </th>
                  <th className="sticky top-0 bg-[#222] p-6 text-left text-[1.8rem] font-semibold text-white">
                    MPN
                  </th>
                </tr>
              </thead>
              <tbody>
                {product.variations
                  .sort((a, b) =>
                    a.mpn?.length && b.mpn?.length
                      ? a.mpn[0].localeCompare(b.mpn[0])
                      : 0
                  )
                  .map((variation, index) => {
                    if (!variation.mpn?.length) return null;
                    return (
                      <tr
                        key={`${variation.size}-${variation.color}-${index}`}
                        className={`h-[5rem] border-y border-[#D9D9D9] ${
                          index % 2 === 0 ? 'bg-transparent' : 'bg-[#F6F6F6]'
                        }`}
                      >
                        <td className="break-words border-r border-[#D9D9D9] px-2 pl-4 text-[1.8rem]">
                          {variation.size !== 'N/A' ? variation.size : ''}
                          {variation.size !== 'N/A' && variation.color
                            ? ' / '
                            : ''}
                          {variation.color ? variation.color : ''}
                        </td>
                        <td className="break-words px-2 pl-8 text-[1.8rem]">
                          {variation.mpn[0]}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        ) : product.mpn?.length ? (
          <div className="relative max-h-[40rem] w-full overflow-y-scroll border-[1px] border-zinc-200">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="sticky top-0 border-r border-[#D9D9D9] bg-[#222] p-6 text-left text-[1.8rem] font-semibold text-white">
                    MPN
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  className={
                    'h-[5rem] border-y border-[#D9D9D9] bg-transparent'
                  }
                >
                  <td className="break-words border-r border-[#D9D9D9] px-2 pl-4 text-[1.8rem]">
                    {product.mpn[0]}
                  </td>
                </tr>
                {/* {product.mpn.map((mpn, index) => {
                  if (!mpn?.length) return null;
                  return (
                    <tr
                      key={mpn + index}
                      className={`h-[5rem] border-y border-[#D9D9D9] ${
                        index % 2 === 0 ? 'bg-transparent' : 'bg-[#F6F6F6]'
                      }`}
                    >
                      <td className="break-words border-r border-[#D9D9D9] px-2 pl-4 text-[1.8rem]">
                        {mpn}
                      </td>
                    </tr>
                  );
                })} */}
              </tbody>
            </table>
          </div>
        ) : product.sku ? (
          <div className="flex flex-row">
            <p className="w-[12rem] text-[1.6rem]">SKU:</p>
            <span className="grow text-[1.6rem] font-semibold text-brand-black">
              {product.sku}
            </span>
          </div>
        ) : null}
      </div>

      <div className="mt-8 flex w-full sm:hidden">
        {product.variations?.length ? (
          <div className="flex w-full flex-col">
            {product.variations.map((variation, index) => (
              <div
                className={`${
                  index % 2 == 0 ? 'bg-white' : 'bg-[#F6F6F6]'
                } flex h-[18rem] w-full flex-col gap-y-8 border-[1.5px] border-[#D9D9D9] p-8`}
                key={`${variation.size}-${variation.color}-${index}`}
              >
                <div className="flex flex-col gap-y-1">
                  <span className="text-[1.8rem] font-medium text-brand-primary">
                    Product Style
                  </span>
                  <span className="text-[1.8rem] font-semibold text-black">
                    {variation.color ?? ''} / {variation.size ?? ''}
                  </span>
                </div>
                {!!variation.mpn?.length ? (
                  <div className="flex flex-col gap-y-1">
                    <span className="text-[1.8rem] font-medium text-brand-primary">
                      MPN
                    </span>
                    <span className="text-[1.8rem] font-semibold text-black">
                      {variation.mpn[0]}
                    </span>
                  </div>
                ) : (
                  <div className="flex flex-col gap-y-1">
                    <span className="text-[1.8rem] font-medium text-brand-primary">
                      SKU Number
                    </span>
                    <span className="text-[1.8rem] font-semibold text-black">
                      {variation.sku ?? 'N/A'}
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : product.mpn?.length ? (
          <div className="flex w-full flex-col">
            <div className="flex h-[18rem] w-full flex-col gap-y-8 border-[1.5px] border-[#D9D9D9] p-8">
              <div className="flex flex-col gap-y-1">
                <span className="text-[1.8rem] font-medium text-brand-primary">
                  MPN
                </span>
                <span className="text-[1.8rem] font-semibold text-black">
                  {product.mpn[0]}
                </span>
              </div>
            </div>
          </div>
        ) : product.sku ? (
          <div className="flex flex-row">
            <p className="w-[12rem] text-[1.6rem]">SKU:</p>
            <span className="grow text-[1.6rem] font-semibold text-brand-black">
              {product.sku}
            </span>
          </div>
        ) : null}
      </div>
    </>
  );
}
